"use client";

import { useEffect } from "react";
import { Container } from "@/components/ui/container";
import { Section } from "@/components/ui/section";
import { Button } from "@/components/ui/button";

interface CommunityErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function CommunityError({ error, reset }: CommunityErrorProps) {
  useEffect(() => {
    console.error("Community page error:", error);
  }, [error]);

  return (
    <Section background="white" size="lg">
      <Container className="text-center">
        <h1 className="text-h2 text-ink mb-4">
          Something went wrong
        </h1>
        <p className="text-muted mb-8 max-w-md mx-auto">
          We could not load this part of the Community. Try again, or go back to
          the Community home.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button onClick={reset} variant="primary">
            Try again
          </Button>
          <Button href="/community" variant="secondary">
            Go to Community
          </Button>
        </div>
      </Container>
    </Section>
  );
}
